import React, { useContext } from 'react'
import { EditorContext, IDashboardWidgetElement, IEditorWidget } from '../EditorService'
import { AttributeTable } from 'forms'
import { usePageAttributes } from 'models/hooks'

/**
 * @todo Allow storing the desired attributes in the config
 */
const AttributeWidget = ({}: { leaf: IDashboardWidgetElement }) => {
  const service = useContext(EditorContext)
  const attributes = usePageAttributes(service.page)
  return <AttributeTable page={service.page} attributes={attributes} editable />
}

export const attributeviewerWidget: IEditorWidget = {
  id: 'attributes',
  name: 'Attribute Viewer',
  description: 'Shows the attributes on this page',
  image: require('./img/fieldviewer.png'),
  renderer: (leaf: IDashboardWidgetElement) => <AttributeWidget leaf={leaf} />,
}
